import { Component, ViewChild, Input } from '@angular/core';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'details-btn',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss'],
    standalone: false
})
export class DetailsComponent implements ICellRendererAngularComp {
    public _params: ICellRendererParams & { values?: { text: (data: any) => string, url: (data: any) => string } };
    cell: { row: any, colHeader: string };
    @Input()
    btnText = "Details";
    url = "";

    constructor() {
    }

    agInit(params: ICellRendererParams & { values?: { text: (data: any) => string, url: (data: any) => string, openInNewWindow: boolean } }): void {
        this._params = params;

        this.cell = { row: params.data, colHeader: params.colDef.headerName };

        if (params.values) {
            if (params.values.text != null && params.values.text != undefined)
                this.btnText = params.values.text(params.data);
            if (params.values.url != null && params.values.url != undefined)
                this.url = params.values.url(params.data);
        }
    }

    refresh(params: any): boolean {
        return true;
    }

    click(event: MouseEvent): void {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        // In this case though, we always want to open the details tab in a new window so after having parent fire event, go ahead and open window

        if (this.url !== undefined && this.url !== null && this.url.length > 0) {
            window.open(this.url);
        } else if (this._params && this._params.context && this._params.context.componentParent && this._params.context.componentParent._itemClicked) {
            this._params.context.componentParent._itemClicked(this.cell);
        }
    }
}
